import React from 'react';
import PropTypes from 'prop-types';
import { getDisplayName } from '../../helpers/common';

const withDealerGAEvent = WrappedComponent =>
  class extends React.Component {
    static displayName = `withDealerGAEvent(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      dealerInfo: PropTypes.shape({
        ga_account: PropTypes.string,
      }).isRequired,
    };

    componentDidMount() {
      const { ga } = window;
      const { dealerInfo } = this.props;
      const gaAccount = dealerInfo && dealerInfo.ga_account;

      if (ga && gaAccount) {
        ga('create', gaAccount, 'avtobazar.ua', { name: 'cTracker' });
        ga('cTracker.send', {
          hitType: 'event',
          eventCategory: 'Avtobazar',
          eventAction: 'pageview',
          eventLabel: window.location.href,
        });
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

export default withDealerGAEvent;



// WEBPACK FOOTER //
// ./src/shared/hocs/stats/withDealerGAEvent.js